import React from 'react';
import { PlayerInfoProps } from '@screens/players/types/player.info.props';
import { InfoArea, InfoAreaTitle } from '@screens/players/player.details.tabs/player.info.styles';
import { StatsContainer } from '@screens/players/stats.container';
import { StatRow } from '@screens/players/stat.display';
import BoolDisplay from '@components/bool.display';
import { formatStringDate } from '@domain/utils/format.utils';

export const LuckySpinInfo = ({ info }: PlayerInfoProps) => {
  const luckySpin = info.detailLuckySpin;
  if (!luckySpin) return null;

  return (
    <InfoArea>
      <InfoAreaTitle>Lucky Spin</InfoAreaTitle>
      <StatsContainer outlined column expandHeight>
        <StatRow label='Purchased'>
          <BoolDisplay value={luckySpin.purchased} />
        </StatRow>
        <StatRow label='Expire Date'>{formatStringDate(luckySpin.expireDate)}</StatRow>
        <StatRow label='Product'>{luckySpin.product}</StatRow>
      </StatsContainer>
    </InfoArea>
  );
};
